<div class="padding-large page-layout margin-large">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Orders</h4>
		</div>
	</div>

	<div class="chip-container">
		@let labelIds = getLabelIds();
		<div (click)="openDialogIdsFilter()" class="filter-chip" [ngClass]="!labelIds ? '' : 'selected'">
			@if (labelIds) {
				<b>Order ID:</b>
				{{ labelIds }}
				<mat-icon (click)="clearIdsFilter($event)">close</mat-icon>
			} @else {
				Order ID
				<mat-icon>edit</mat-icon>
			}
		</div>

		@for (element of filtersList; track element) {
			@let label = getLabel(element.id);
			<div (click)="openDialogFilter(element.id)" class="filter-chip" [ngClass]="!label ? '' : 'selected'" [title]="getFullTitleFilter(element.id)">
				@if (label) {
					<b>{{ element.label }}</b>
					: {{ label }}
					<mat-icon (click)="clearFilter($event, element.id)">close</mat-icon>
				} @else {
					{{ element.label }}
					<mat-icon>edit</mat-icon>
				}
			</div>
		}

		@for (element of dateFiltersList; track element) {
			@let label = getLabelDate(element.id);
			<div (click)="openDialogDateFilter(element.id)" class="filter-chip" [ngClass]="!label ? '' : 'selected'">
				@if (label) {
					<b>{{ element.label }}</b>
					: {{ label }}
					<mat-icon (click)="clearFilter($event, element.id)">close</mat-icon>
				} @else {
					{{ element.label }}
					<mat-icon>edit</mat-icon>
				}
			</div>
		}
	</div>

	<div class="margin-top-small">
		<div class="flex margin-bottom-small">
			<div class="flex-1 flex end">
				<span class="grey">{{ orders.total }} orders</span>
			</div>

			<button (click)="onCustomOrder()">
				<mat-icon>add</mat-icon>
				Create custom order
			</button>
		</div>

		@if (orders.data.length) {
			<table class="basic-table">
				<tr>
					<th>Order</th>
					<th>Photographer</th>
					<th>Creation Date</th>
					<th>Due Date</th>
					<th>Completion Date</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
				@for (item of orders.data; track item) {
					<tr>
						<td>
							{{ item.orderNumber }}
						</td>
						<td>{{ item.photographerFullName }}</td>
						<td>
							{{ item.creationDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.dueDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							{{ item.completionDate | date: 'dd-MM-yyyy' }}
						</td>
						<td>
							<span [class]="'status-chip-' + item.orderStatusName.toLowerCase()">
								{{ item.orderStatusName }}
							</span>
						</td>
						<td>
							<div class="flex center full-width">
								<span class="hover flex center primary" (click)="onInfo(item)">
									<mat-icon class="small margin-right-smallest">visibility</mat-icon>
									Open
								</span>
								@if (item.orderStatusId === 1) {
									<span class="margin-left-small hover flex center red" (click)="deleteOrder(item.orderId)">
										<mat-icon class="small">close</mat-icon>
										Remove
									</span>
								}
							</div>
						</td>
					</tr>
				}
			</table>

			<bt-paginator [pageNumber]="orders.page" [pageSize]="orders.size" [totalNumber]="orders.total" (clickPage)="getOrders($event)"></bt-paginator>
		}
		@if (orders.data && !orders.data.length && !orders.page) {
			<div class="padding-large flex column center grey margin-top-large">
				<i class="fa fa-search big margin-bottom-smallest"></i>
				<h4>No data found</h4>
			</div>
		}
	</div>
</div>
